"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addPOSTHeaders = addPOSTHeaders;
exports.default = genericFetch;
exports.enhanceWithSesionIdAndUserId = enhanceWithSesionIdAndUserId;
exports.enhanceWithToken = enhanceWithToken;
exports.rawGenericFetch = void 0;
exports.validateStatus = validateStatus;
var _axios = _interopRequireDefault(require("axios"));
var _genericFetch = require("../utils/genericFetch");
var _cookieHelper = require("../utils/cookieHelper");
var _cacheHelper = require("../utils/cacheHelper");
var _ApiConst = require("../utils/ApiConst");
var _utils = require("../utils/utils");
_axios.default.defaults.timeout = 35000;

/**
 * Checks if a network request came back fine, and throws an error if not
 */
function validateStatus(status) {
  if (status >= 200 && status < 300 || status === 403 || status === 400) {
    return true;
  }
  return false;
  // throw { errorCode: status, errorMessage: "Service Temporarily Unavailable " };
}
function enhanceWithToken(tokenData) {
  let token = _ApiConst.isThereMobile ? (tokenData === null || tokenData === void 0 ? void 0 : tokenData.token) || '' : (0, _cookieHelper.getDataFromCookieAToB)('kcToken');
  if (tokenData && tokenData.isAccessTokenAvailable || !_ApiConst.isThereMobile && token) {
    token = `Bearer ${token}`;
  } else {
    if (!_ApiConst.isThereMobile) {
      token = (0, _cookieHelper.getDataFromCookie)('Guest_Token');
    }
    token = `guest-token ${token}`;
  }
  // console.log('===token', token);
  return {
    headers: {
      Authorization: token || null
    }
  };
}
function enhanceWithSesionIdAndUserId(options = {}, userId = null) {
  const sessionId = _ApiConst.isThereMobile ? window.deviceID : (0, _cookieHelper.getDataFromCookie)('deviceId');
  if (userId) {
    return {
      ...options,
      headers: {
        ...(options === null || options === void 0 ? void 0 : options.headers),
        sessionId,
        userId
      }
    };
  } else {
    return {
      ...options,
      headers: {
        ...(options === null || options === void 0 ? void 0 : options.headers),
        sessionId
      }
    };
  }
}
function addPOSTHeaders(options = {}) {
  var _window;
  const deviceId = _ApiConst.isThereMobile ? window.deviceID : (0, _cookieHelper.getDataFromCookie)('deviceId');
  const strPlatform = _ApiConst.isThereMobile ? window.nativePlatform || 'mobile' : 'web';
  const traceId = (0, _utils.generateTraceId)();
  return {
    ...options,
    headers: {
      ...(_ApiConst.isThereMobile && {
        appVersion: (_window = window) === null || _window === void 0 ? void 0 : _window.appVersion
      }),
      Accept: 'application/json',
      'Strict-Transport-Security': 'max-age=31536000; includeSubDomains',
      'X-Frame-Options': 'SAMEORIGIN',
      'X-Content-Type-Options': 'nosniff',
      'Content-Security-Policy': 'script-src "self"',
      'Permissions-Policy': 'payment=()"',
      'Referrer-Policy': 'strict-origin',
      'X-XSS-Protection': '1; mode=block',
      'Content-Type': options.isMultipartRequest === true ? 'multipart/form-data' : 'application/json; charset=UTF-8',
      'x-patient-apiversion': '2.2.5',
      'X-User-Agent': _ApiConst.isThereMobile ? 'aster-mobile/2.1' : 'aster-web/2.1',
      deviceId,
      platform: strPlatform,
      traceId: traceId,
      ...options.headers
    }
  };
}
function parseBody(options = {}) {
  return options.body && !options.dropBodyStringifying ? {
    ...options,
    body: JSON.stringify(options.body)
  } : options;
}
function parseResponse(response, cacheKey) {
  if ((response === null || response === void 0 ? void 0 : response.status) !== 200 && (response === null || response === void 0 ? void 0 : response.status) !== 201 && (response === null || response === void 0 ? void 0 : response.status) !== 204) {
    var _response$data, _response$data2, _response$data3, _response$data4;
    const error = {
      errorCode: response !== null && response !== void 0 && response.data && response !== null && response !== void 0 && (_response$data = response.data) !== null && _response$data !== void 0 && _response$data.code ? response === null || response === void 0 || (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : _response$data2.code : (response === null || response === void 0 ? void 0 : response.status) || '',
      errorMessage: response !== null && response !== void 0 && response.data && response !== null && response !== void 0 && (_response$data3 = response.data) !== null && _response$data3 !== void 0 && _response$data3.msg ? response === null || response === void 0 || (_response$data4 = response.data) === null || _response$data4 === void 0 ? void 0 : _response$data4.msg : '',
      errorResponse: (response === null || response === void 0 ? void 0 : response.data) || response
    };
    throw error;
  }
  if (response && response !== null && response !== void 0 && response.data && response !== null && response !== void 0 && response.status) {
    var _response$request;
    response.data = {
      ...(typeof response.data !== 'object' ? {
        data: response === null || response === void 0 ? void 0 : response.data
      } : {
        ...(response === null || response === void 0 ? void 0 : response.data)
      }),
      status: response === null || response === void 0 ? void 0 : response.status,
      responseURL: response === null || response === void 0 || (_response$request = response.request) === null || _response$request === void 0 ? void 0 : _response$request.responseURL
    };
  }
  if (cacheKey) {
    (0, _cacheHelper.addItemToCache)(cacheKey, (response === null || response === void 0 ? void 0 : response.data) || response);
  }
  return (response === null || response === void 0 ? void 0 : response.data) || response;
}
function parseError(error, options) {
  // console.log('===parseError err', err);
  throw (0, _genericFetch.getGenericErrorObject)({
    error,
    options
  });
}
const rawGenericFetch = (options, cacheKey) => (0, _axios.default)(options).then(response => parseResponse(response, cacheKey)).catch(err => parseError(err, options));

/**
 * Requests a URL, returning a promise
 *
 * @param {string} url The URL we want to request
 * @param {object} [options] The options we want to pass to "fetch"
 *
 * @return {object} The response data
 */
exports.rawGenericFetch = rawGenericFetch;
function genericFetch({
  apiEndPoint,
  options,
  formData,
  enableCache
}) {
  var _window2, _window$countryCode, _window3, _window$timeZoneStrin, _window$languageCode, _window4, _window5;
  const regionCode = _ApiConst.isThereMobile ? '' : (0, _cookieHelper.getDataFromCookie)('regionCode');
  const langCode = _ApiConst.isThereMobile ? '' : (0, _cookieHelper.getDataFromCookie)('langCode');
  const timezone = _ApiConst.isThereMobile ? '' : (0, _cookieHelper.getDataFromCookie)('timezone');
  const addUpdatedHeader = {
    ...options,
    headers: {
      ...options.headers,
      'Client-Id': _ApiConst.isThereMobile ? (_window2 = window) === null || _window2 === void 0 ? void 0 : _window2.nativePlatform : 'web',
      'new-auth-service': true,
      'x-country-code': _ApiConst.isThereMobile ? (_window$countryCode = (_window3 = window) === null || _window3 === void 0 ? void 0 : _window3.countryCode) !== null && _window$countryCode !== void 0 ? _window$countryCode : 'AE' : regionCode !== null && regionCode !== void 0 ? regionCode : _ApiConst.DEFAULT_HEADER_VALUES.regionCode,
      'x-site-time-zone': _ApiConst.isThereMobile ? (_window$timeZoneStrin = window.timeZoneString) !== null && _window$timeZoneStrin !== void 0 ? _window$timeZoneStrin : 'Asia/Dubai' : timezone !== null && timezone !== void 0 ? timezone : _ApiConst.DEFAULT_HEADER_VALUES.timezone,
      'x-language': _ApiConst.isThereMobile ? (_window$languageCode = (_window4 = window) === null || _window4 === void 0 ? void 0 : _window4.languageCode) !== null && _window$languageCode !== void 0 ? _window$languageCode : 'en' : langCode !== null && langCode !== void 0 ? langCode : _ApiConst.DEFAULT_HEADER_VALUES.langCode,
      ...(_ApiConst.isThereMobile ? {
        Origin: _ApiConst.WEBSITE_URL
      } : {}),
      ...(_ApiConst.isThereMobile && (_window5 = window) !== null && _window5 !== void 0 && _window5.disableLocalAPICache ? {
        'Cache-Control': 'no-cache',
        Pragma: 'no-cache',
        Expires: '0'
      } : {})
    }
  };
  const optionsWithHeaders = addPOSTHeaders(addUpdatedHeader);
  let parsedOptions;
  if (formData) {
    parsedOptions = optionsWithHeaders;
    parsedOptions.timeout = 600000;
  } else {
    parsedOptions = parseBody(optionsWithHeaders);
  }
  parsedOptions.url = apiEndPoint;
  parsedOptions.data = parsedOptions.body;
  if (formData) {
    // delete parsedOptions.body;
    parsedOptions.transformRequest = (data, error) => {
      return parsedOptions.body;
    };
  }
  parsedOptions.validateStatus = validateStatus;
  parsedOptions.onUploadProgress = options.onUploadProgress;
  let cacheKey;
  if (enableCache) {
    cacheKey = (0, _utils.generateCacheKey)(apiEndPoint, parsedOptions.data);
    (0, _cacheHelper.removeCacheItem)(cacheKey);
    if ((0, _cacheHelper.getCacheItem)(cacheKey)) {
      return Promise.resolve((0, _cacheHelper.getCacheItem)(cacheKey));
    }
  }
  return rawGenericFetch(parsedOptions, cacheKey);
}